import React from 'react'
import cn from 'classnames'
import { HomepageCarousel } from 'components/HomepageCarousel'
import { useCarouselSpringboardExp } from 'experiments/pen-5453_v1_hp_carousel_to_quiz'
import { QuizOnlyOnce } from './components/QuizOnlyOnce'
import styles from './HeroQuiz.module.scss'

export const HeroQuiz = () => {
  const { isPen5453Variant } = useCarouselSpringboardExp()

  return (
    <div className='container'>
      <div className='row no-gutters'>
        <div className='col-12 col-md-7 col-lg-6'>
          <QuizOnlyOnce />
        </div>
        <div className='d-none d-md-block d-lg-none col-md-1' />
        <div
          className={cn('col-12 col-md-4 col-lg-6', styles.carousel, {
            [styles.pen5453Variant]: isPen5453Variant,
          })}
        >
          <HomepageCarousel />
        </div>
      </div>
    </div>
  )
}
